
<div>

</div>

<style>
    div {
        background-color: #343a40;
        position: fixed;
        width: 100%;
        height: 48px;
    }
</style>